import React, { useState } from 'react';
import { ToastContainer } from 'react-toastify';
import AppApiKeys from './AppApiKeys';
import CreateAppApiKeyModal from './CreateAppApiKeyModal';
import CreateTrackApiKeyModal from './CreateTrackApiKeyModal';
import TrackingApiKeys from './TrackingApiKeys';
// @ts-ignore: CSS side-effect import without type declarations
import 'react-toastify/dist/ReactToastify.css';

const ApiCredentialsTabs: React.FC = () => {
  const [activeTab, setActiveTab] = useState<
    'Tracking API keys' | 'App API  keys'
  >('Tracking API keys');

  // const apiKeys = useSelector((state: RootState) => state.apiKeys.keys);

  // Modal state
  const [isCreateTrackOpen, setIsCreateTrackOpen] = useState(false);
  const [isCreateAppOpen, setIsCreateAppOpen] = useState(false);
  // const [isEditOpen, setIsEditOpen] = useState(false);
  // const [selectedKey, setSelectedKey] = useState<ApiKey | null>(null);

  return (
    <div className='bg-white border border-gray-200 rounded-md mt-6 shadow-sm'>
      {/* Tabs */}
      <div className='flex justify-between items-center px-6 pt-4'>
        <div className='flex space-x-6'>
          {['Tracking API keys', 'App API  keys'].map((tab) => (
            <button
              key={tab}
              onClick={() => {
                setActiveTab(
                  tab as 'Tracking API keys' | 'App API  keys'
                );
              }}
              className={`pb-2 font-medium text-[14px] ${activeTab === tab
                ? 'border-b-2 border-[#00899E] text-[#00899E]'
                : 'text-gray-500'
                }`}
            >
              {tab}
            </button>
          ))}
        </div>
      </div>

      {/* Content */}
      <div className='px-6 py-4'>
        {activeTab === 'Tracking API keys' && (
          <>
            <div className='flex items-center justify-between mb-4'>
              <p className='text-[#657584] text-[16px]'>
                These keys let you send data to our tracking endpoints and set
                up the JavaScript snippet, but they don't grant access to the
                main App API.
              </p>
              <button
                onClick={() => setIsCreateTrackOpen(true)}
                className='bg-orange-500 text-white px-4 py-2 rounded text-[14px]'
              >
                Create Track API Key
              </button>
            </div>
            <TrackingApiKeys />
          </>
        )}

        {activeTab === 'App API  keys' && (
          <>
            <div className='flex items-center justify-between mb-4'>
              <p className='text-[#657584] text-[16px]'>
                These keys provide full access to the App API endpoints and should be kept secure.
                They are used for server-to-server communication.
              </p>
              <button
                onClick={() => setIsCreateAppOpen(true)}
                className='bg-orange-500 text-white px-4 py-2 rounded text-[14px]'
              >
                Create App API Key
              </button>
            </div>
            <AppApiKeys />
          </>
        )}
      </div>

      {/* Modals */}
      <CreateTrackApiKeyModal
        isOpen={isCreateTrackOpen}
        onClose={() => setIsCreateTrackOpen(false)}
      />
      <CreateAppApiKeyModal
        isOpen={isCreateAppOpen}
        onClose={() => setIsCreateAppOpen(false)}
      />
      <ToastContainer position='top-right' autoClose={3000} />
    </div>
  );
};

export default ApiCredentialsTabs;